import React, { useRef, useEffect } from "react";
import BOQTimeline from "./BOQTimeline";
import ProjectTimeline from "./ProjectTimeline";
import { FiMessageCircle } from "react-icons/fi";

const TimelineComponent = ({ data, setProjectData, selectedTab, onChatToggle, searchQuery = "" }) => {
  const containerRef = useRef(null);

  // Log data changes for debugging
  useEffect(() => {
    console.log('🔄 TimelineComponent received data update:', data?.length, 'items');
    if (data && data.length > 0) {
      console.log('📝 First few tasks:', data.slice(0, 3).map(t => `${t.serialNumber}: ${t.taskName.substring(0, 15)}`));
    }
  }, [data]);

  // Scroll to bottom when new tasks are added
  useEffect(() => {
    if (data && data.length > 0) {
      setTimeout(() => {
        if (containerRef.current) {
          const container = containerRef.current;
          const isNearBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 100;
          
          // Only auto-scroll if user is near the bottom or if this is a new task (check last task properties)
          const lastTask = data[data.length - 1];
          if (isNearBottom || (lastTask && lastTask.taskName === "Tap to enter")) {
            container.scrollTo({
              top: container.scrollHeight,
              behavior: "smooth",
            });
          }
        }
      }, 150);
    }
  }, [data?.length]);

  return (
    <div style={styles.container} ref={containerRef}>
      {
        console.log('TimelineComponent data : ', data)
      }
      {selectedTab === "BOQ timeline" ? (
        <BOQTimeline data={data} setProjectData={setProjectData} searchQuery={searchQuery} />
      ) : (
        <ProjectTimeline data={data} setProjectData={setProjectData} searchQuery={searchQuery} />
      )}
      <button style={styles.chatButton} onClick={onChatToggle}>
        <FiMessageCircle size={24} />
      </button>
    </div>
  );
};

const styles = {
  container: {
    width: "100%",
    padding: "0",
    marginTop: "0",
    position: "relative",
    height: "100vh",
    overflowY: "auto", // make it scrollable
  },
  chatButton: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    backgroundColor: "#4A6CF7",
    color: "#fff",
    fontSize: "24px",
    border: "none",
    cursor: "pointer",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.3)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.3s ease",
    zIndex: 1000,
  },
};

export default TimelineComponent;
